module.exports = __webpack_public_path__ + "fonts/Poppins-600-devanagari13.3343afa.woff2";